import type { IssueMessages, Messages } from '../messages.ts';

export const pt: Messages = {
  'app.name': 'FreExam Player',
  'app.tagline': 'Faça simulados em JSON inteiramente no seu navegador.',
  'app.privacy':
    'Seus arquivos de prova e suas respostas são processados localmente no seu navegador e não são enviados a nenhum servidor.',
  'app.skipToContent': 'Ir para o conteúdo',
  'app.textSizeValue': '{percent}%',

  'import.title': 'Abrir uma prova',
  'import.instructions': 'Escolha um arquivo .json no seu dispositivo, ou solte um aqui.',
  'import.choose': 'Escolher arquivo',
  'import.dropHere': 'Solte o arquivo aqui',
  'import.reading': 'Lendo o arquivo…',
  'import.validating': 'Verificando o arquivo…',
  'import.example': 'Ver uma prova de exemplo',
  'import.formatHelp': 'O que é um arquivo de prova?',
  'import.downloadTemplate': 'Baixar schema modelo',
  'import.downloadTemplateHint': 'Entregue a qualquer IA junto com seu material para montar um arquivo de prova.',
  'import.again': 'Abrir outro arquivo',

  'exam.loaded': '{title} carregada',
  'exam.questionCount': '{count} questões',
  'exam.license': 'Licença: {license}',
  'exam.licenseUnknown': 'Licença não declarada',
  'exam.source': 'Fonte: {source}',
  'exam.warnings': 'Carregada com {count} avisos',
  'exam.viewReport': 'Ver relatório',

  'report.title': 'Este arquivo não pode ser usado',
  'report.titleWarnings': 'O arquivo carregou, com pontos que valem conferir',
  'report.summary': '{errors} erros, {warnings} avisos',
  'report.download': 'Baixar validation-report.json',
  'report.copy': 'Copiar relatório',
  'report.copied': 'Copiado',
  'report.tryAnother': 'Tentar outro arquivo',
  'report.suppressed': 'e mais {count} do mesmo tipo',
  'report.question': 'Questão {id}',
  'report.expected': 'Esperado',
  'report.received': 'Encontrado',
  'report.location': 'Local',
  'report.noIssues': 'Nenhum problema encontrado.',
  'report.severity.error': 'Erro',
  'report.severity.warning': 'Aviso',
  'report.severity.info': 'Nota',

  'config.title': 'Configurar a sessão',
  'config.mode': 'Modo',
  'config.mode.exam': 'Prova',
  'config.mode.exam.description': 'Com tempo, nada revelado até você enviar.',
  'config.mode.practice': 'Estudo',
  'config.mode.practice.description': 'Sem relógio, respostas e explicações no caminho.',
  'config.mode.custom': 'Personalizado',
  'config.mode.custom.description': 'Escolha cada opção você mesmo.',
  'config.questionCount': 'Número de questões',
  'config.all': 'Todas ({count})',
  'config.matching': '{count} questões correspondem aos filtros',
  'config.matchingOne': '1 questão corresponde aos seus filtros',
  'config.noMatches': 'Nenhuma questão corresponde a estes filtros.',
  'config.filters': 'Filtros',
  'config.category': 'Categoria',
  'config.topic': 'Tópico',
  'config.difficulty': 'Dificuldade',
  'config.type': 'Tipo de questão',
  'config.tag': 'Tag',
  'config.seed': 'Semente',
  'config.seedHelp': 'A mesma semente sorteia as mesmas questões na mesma ordem.',
  'config.newSeed': 'Nova semente',
  'config.timeLimit': 'Tempo total (minutos)',
  'config.noTimeLimit': 'Sem limite de tempo',
  'config.shuffleQuestions': 'Embaralhar questões',
  'config.shuffleOptions': 'Embaralhar alternativas',
  'config.immediateFeedback': 'Mostrar a resposta após cada questão',
  'config.allowBack': 'Permitir voltar',
  'config.allowChange': 'Permitir alterar respostas',
  'config.start': 'Começar',
  'config.back': 'Voltar',
  'config.candidateName': 'Seu nome',
  'config.candidateNamePlaceholder': 'Opcional',
  'config.candidateNameHelp':
    'Aparece enquanto você faz a prova e é gravado nos resultados que você exportar. Fica no seu dispositivo.',
  'config.timer': 'Cronômetro',
  'config.timerOn': 'Cronômetro ligado',
  'config.useRange': 'Somente um intervalo de questões',
  'config.rangeFrom': 'De',
  'config.rangeTo': 'Até',
  'config.rangeHelp': 'Numeradas como aparecem no arquivo, de 1 a {total}.',
  'config.weakest': 'O que você errou',
  'config.onlyIncorrect': 'Somente questões que eu errei ({count} disponíveis)',
  'config.incorrectAtLeast': 'Pelo menos esta quantidade de vezes',
  'config.device': 'Este dispositivo',
  'config.remember': 'Lembrar meu progresso neste dispositivo',
  'config.rememberHelp':
    'Registra quais questões você erra e permite salvar uma sessão para continuar depois. Fica neste navegador e nunca é enviado. Desligado até você ligar.',
  'config.remembered': '{count} questões estão registradas como erradas.',
  'config.forget': 'Apagar tudo deste dispositivo',

  'difficulty.easy': 'Fácil',
  'difficulty.medium': 'Médio',
  'difficulty.hard': 'Difícil',

  'type.single-choice': 'Escolha única',
  'type.multiple-choice': 'Múltipla escolha',
  'type.matching': 'Associação',
  'type.ordering': 'Ordenação',
  'type.text': 'Resposta escrita',

  'session.question': 'Questão {position} de {total}',
  'session.previous': 'Anterior',
  'session.next': 'Próxima',
  'session.mark': 'Marcar para revisão',
  'session.marked': 'Marcada para revisão',
  'session.report': 'Relatar um problema',
  'session.submit': 'Enviar',
  'session.navigator': 'Questões',
  'session.timeRemaining': 'Tempo restante',
  'session.timeUp': 'Tempo esgotado',
  'session.paused': 'Pausada',
  'session.selectCount': 'Escolha {count}',
  'session.selectRange': 'Escolha entre {min} e {max}',
  'session.answerHere': 'Sua resposta',
  'session.checkAnswer': 'Conferir resposta',
  'session.correct': 'Correta',
  'session.incorrect': 'Incorreta',
  'session.explanation': 'Explicação',
  'session.references': 'Referências',
  'session.status.answered': 'respondida',
  'session.status.unanswered': 'não respondida',
  'session.status.marked': 'marcada para revisão',
  'session.status.current': 'questão atual',
  'session.moveUp': 'Mover para cima',
  'session.moveDown': 'Mover para baixo',
  'session.position': 'Posição {position}',
  'session.matchWith': 'Associar a',
  'session.chooseTarget': 'Escolher…',
  'session.sourceNumber': 'Q{number} do arquivo',
  'session.pause': 'Pausar',
  'session.resume': 'Continuar',
  'session.pausedHelp': 'O cronômetro está parado e as questões estão ocultas.',
  'session.save': 'Salvar sessão',
  'session.saved': 'Sessão salva neste dispositivo.',
  'session.saveFailed': 'Não foi possível salvar a sessão neste dispositivo.',
  'session.review': 'Revisar',
  'session.reviewAll': 'Todas ({count})',
  'session.reviewMarked': 'Marcadas ({count})',
  'session.reviewUnanswered': 'Sem resposta ({count})',
  'session.goToNext': 'Ir para a próxima',
  'session.reviewEmpty': 'Nada aqui.',

  'note.add': 'Adicionar uma nota',
  'note.label': 'Sua nota sobre esta questão',
  'note.placeholder': 'O que confundiu você, o que pesquisar, o que quer lembrar.',
  'note.help': 'As notas ficam no seu dispositivo. Você lê todas juntas ao terminar.',
  'note.remaining': 'Restam {count} caracteres.',
  'note.summaryTitle': 'Suas notas ({count})',
  'note.export': 'Exportar notas',
  'note.includeQuestions': 'Incluir as questões, para eu estudar por este arquivo',
  'note.exportHelp':
    'Um arquivo Markdown legível com suas notas e o número das questões a que pertencem. Não contém as questões em si.',
  'note.exportHelpWithQuestions':
    'Um arquivo Markdown legível com cada questão anotada, as alternativas como você as viu, sua resposta, a resposta certa e a explicação. Contém o conteúdo da prova — trate-o como a licença dela pede.',

  'controls.textSize': 'Tamanho do texto',
  'controls.textSize.description': 'Deixe as questões maiores ou menores.',
  'controls.language': 'Idioma',
  'controls.language.description': 'O idioma desta interface, não o da prova.',
  'controls.focus': 'Modo foco',
  'controls.focus.description': 'Mostrar apenas a questão atual.',
  'controls.theme': 'Tema',
  'controls.theme.description': 'Claro, escuro, ou o que o seu dispositivo usa.',
  'controls.theme.system': 'Acompanhar o dispositivo',
  'controls.theme.light': 'Claro',
  'controls.theme.dark': 'Escuro',

  'correct.open': 'Corrigir esta questão',
  'correct.title': 'O que deveria estar escrito',
  'correct.help':
    'Só você vê isto. Ao terminar, a tela de resultados oferece uma cópia corrigida da prova para enviar a quem a escreveu.',
  'correct.reason': 'O que está errado',
  'correct.reason.incorrect-answer': 'O gabarito está errado',
  'correct.reason.incorrect-explanation': 'A explicação está errada',
  'correct.reason.typo': 'Um erro de digitação',
  'correct.reason.media-description': 'A imagem precisa de descrição',
  'correct.reason.ambiguous-question': 'A questão é ambígua',
  'correct.reason.outdated-content': 'O conteúdo está desatualizado',
  'correct.reason.conversion-error': 'Algo se perdeu na conversão',
  'correct.reason.translation-error': 'A tradução está errada',
  'correct.reason.other': 'Outra coisa',
  'correct.answer': 'A resposta certa',
  'correct.optionText': 'O texto de cada alternativa',
  'correct.explanation': 'A explicação',
  'correct.mediaDescription': 'O que a imagem mostrava: {alt}',
  'correct.note': 'Outra coisa que o autor deveria saber',
  'correct.discard': 'Descartar esta correção',
  'correct.export': 'Exportar prova corrigida',
  'correct.exportHelp':
    'Um arquivo de prova completo com suas correções, registrando de qual prova veio e o que você mudou. Contém o conteúdo da prova, então a licença dela governa o que você pode fazer com ele.',

  'update.available': 'Uma nova versão do player está pronta.',
  'update.apply': 'Recarregar agora',
  'update.later': 'Agora não',

  'focus.open': 'Foco',
  'focus.title': 'Modo foco',
  'focus.exit': 'Fechar',

  'calculator.title': 'Calculadora',
  'calculator.close': 'Fechar',
  'calculator.error': 'Não é possível dividir por zero',

  'resume.title': 'Você tem uma sessão salva desta prova',
  'resume.draftTitle': 'Você estava no meio desta prova',
  'resume.detail': '{answered} de {total} questões respondidas.',
  'resume.continue': 'Continuar',
  'resume.discard': 'Descartar',

  'media.wasImage': 'A questão original continha uma imagem.',
  'media.unavailable': 'A imagem não está incluída neste arquivo.',
  'media.remote': 'A imagem está hospedada em outro lugar e não é carregada automaticamente.',
  'media.description': 'Descrição',

  'submit.title': 'Enviar suas respostas?',
  'submit.complete': 'Você respondeu todas as questões.',
  'submit.incomplete': '{count} questões não foram respondidas.',
  'submit.marked': '{count} questões estão marcadas para revisão.',
  'submit.confirm': 'Enviar',
  'submit.cancel': 'Continuar',

  'results.title': 'Resultado',
  'results.score': '{percent}%',
  'results.scoreOf': '{raw} de {max} pontos',
  'results.passed': 'Aprovado',
  'results.failed': 'Não aprovado',
  'results.correct': 'Corretas',
  'results.incorrect': 'Incorretas',
  'results.unanswered': 'Não respondidas',
  'results.partial': 'Parciais',
  'results.ungraded': 'Sem correção automática',
  'results.ungradedHelp':
    'São respostas escritas que o app não consegue corrigir. Revise-as e decida você mesmo.',
  'results.duration': 'Tempo gasto',
  'results.averagePerQuestion': 'Média por questão',
  'results.byCategory': 'Por categoria',
  'results.byDifficulty': 'Por dificuldade',
  'results.byType': 'Por tipo de questão',
  'results.byTag': 'Por tag',
  'results.review': 'Revisar respostas',
  'results.export': 'Exportar resultado',
  'results.newSession': 'Nova sessão',
  'results.markedCount': 'Marcadas para revisão',
  'results.yourAnswer': 'Sua resposta',
  'results.correctAnswer': 'Resposta correta',
  'results.markCorrect': 'Acertei',
  'results.markIncorrect': 'Errei',
  'results.noAnswer': 'Sem resposta',

  'reportQuestion.title': 'Relatar um problema nesta questão',
  'reportQuestion.help':
    'Isto fica no seu dispositivo. É salvo junto com o resultado exportado e pode ser usado para gerar uma cópia corrigida da prova.',
  'reportQuestion.reason.incorrect-answer': 'O gabarito está errado',
  'reportQuestion.reason.ambiguous-question': 'A questão é ambígua',
  'reportQuestion.reason.incorrect-explanation': 'A explicação está errada',
  'reportQuestion.reason.outdated-content': 'O conteúdo está desatualizado',
  'reportQuestion.reason.conversion-error': 'Algo se perdeu na conversão',
  'reportQuestion.reason.translation-error': 'A tradução está errada',
  'reportQuestion.reason.other': 'Outra coisa',
  'reportQuestion.comment': 'Mais alguma coisa? (opcional)',
  'reportQuestion.save': 'Salvar',
  'reportQuestion.cancel': 'Cancelar',
  'reportQuestion.saved': 'Relato salvo',

  'common.close': 'Fechar',
  'common.cancel': 'Cancelar',
  'common.of': 'de',
  'common.minutes': '{count} min',
  'common.seconds': '{count} s',
};

export const ptIssues: IssueMessages = {
  FILE_EMPTY: 'O arquivo está vazio.',
  FILE_TOO_LARGE: 'O arquivo é maior do que este app abre ({expected}).',
  FILE_UNSUPPORTED_EXTENSION: 'Só é possível abrir arquivos {expected}.',
  FILE_READ_FAILED: 'Não foi possível ler o arquivo. Ele pode ter sido movido ou renomeado.',
  FILE_NOT_UTF8: 'O arquivo não é texto UTF-8 válido. Salve-o novamente como UTF-8.',

  SEC_DEPTH_EXCEEDED: 'O arquivo tem aninhamento profundo demais para uma prova.',
  SEC_NODES_EXCEEDED: 'O arquivo contém muito mais dados do que uma prova deveria.',
  SEC_PROTO_POLLUTION_KEY: 'Chaves inseguras ({received}) foram removidas ao ler o arquivo.',
  SEC_UNSAFE_URL: 'Uma URL do arquivo usa um esquema que não é permitido.',
  SEC_MEDIA_NOT_ALLOWED_TYPE: 'Uma imagem embutida usa um formato que não é permitido.',
  SEC_MEDIA_TYPE_MISMATCH: 'Uma imagem embutida não corresponde ao tipo declarado ({received}).',
  SEC_MEDIA_INVALID_BASE64: 'Uma imagem embutida não está em base64 válido.',
  SEC_MEDIA_TOO_LARGE: 'Uma imagem embutida é maior do que o permitido.',
  SEC_MEDIA_DIMENSIONS_TOO_LARGE:
    'Uma imagem embutida declara mais pixels do que é seguro desenhar. O arquivo é pequeno, mas decodificá-lo não seria.',
  SEC_MEDIA_HEADER_UNREADABLE:
    'Uma imagem embutida tem um cabeçalho que este player não consegue ler, então o tamanho dela não pode ser verificado antes de decodificar.',

  JSON_SYNTAX_ERROR: 'O arquivo não é JSON válido (linha {line}, coluna {column}).',
  JSON_ROOT_NOT_OBJECT: 'Um arquivo de prova precisa ser um objeto JSON, mas isto é {received}.',

  DETECT_MISSING_KIND: 'O arquivo não diz o que é. Adicione "kind": "exam" no início.',
  DETECT_UNKNOWN_KIND: 'Este não é um tipo de arquivo que o app conhece ({received}).',
  DETECT_WRONG_KIND: 'Este é um arquivo de resultado de sessão, não uma prova.',
  DETECT_INVALID_VERSION: 'O schemaVersion não é um número de versão ({received}).',
  DETECT_UNSUPPORTED_MAJOR: 'Este arquivo usa o formato {received}; o app entende {expected}.',
  DETECT_NEWER_MINOR:
    'Este arquivo foi escrito para uma versão mais recente do formato ({received}). O que for desconhecido será ignorado.',

  SCHEMA_REQUIRED_PROPERTY_MISSING: 'Falta {expected}.',
  SCHEMA_UNKNOWN_PROPERTY: 'Propriedade inesperada {received}.',
  SCHEMA_WRONG_TYPE: 'Esperado {expected}, encontrado {received}.',
  SCHEMA_VALUE_NOT_ALLOWED: 'Esperado {expected}, encontrado {received}.',
  SCHEMA_PATTERN_MISMATCH: 'Esperado {expected}, encontrado {received}.',
  SCHEMA_TEXT_LENGTH_OUT_OF_RANGE: 'Esperado {expected}, encontrado {received}.',
  SCHEMA_ARRAY_LENGTH_OUT_OF_RANGE: 'Esperado {expected}, encontrado {received}.',
  SCHEMA_DUPLICATE_ITEMS: 'Esperado {expected}: {received}.',
  SCHEMA_NUMBER_OUT_OF_RANGE: 'Esperado um número {expected}, encontrado {received}.',
  SCHEMA_FORBIDDEN_COMBINATION: 'Estes campos não podem ser combinados assim.',
  SCHEMA_CONSTRAINT_VIOLATED: 'Este valor não satisfaz o schema.',
  SCHEMA_CONTENT_HASH_NOT_AUTHORABLE:
    'contentHash não pode ser escrito no arquivo: ele é calculado a partir do próprio arquivo. Remova-o.',

  MIGRATION_NO_PATH: 'Não há como converter este arquivo a partir de {expected}.',
  MIGRATION_FIELD_DROPPED: 'Um campo foi descartado na conversão do arquivo.',
  MIGRATION_PRODUCED_INVALID_DOCUMENT:
    'A conversão produziu algo inválido. Isto é um defeito do app, não do seu arquivo.',

  SEM_DUPLICATE_QUESTION_ID: 'Duas questões têm o mesmo id: {received}.',
  SEM_DUPLICATE_OPTION_ID: 'Duas alternativas desta questão têm o mesmo id: {received}.',
  SEM_UNKNOWN_CORRECT_OPTION: 'A resposta correta {received} não está entre as alternativas.',
  SEM_UNKNOWN_TAXONOMY_REF: 'A categoria {received} não está declarada na taxonomia.',
  SEM_TAXONOMY_NOT_DECLARED:
    'As questões estão classificadas, mas a prova não declara taxonomia, então as categorias não podem ser conferidas.',
  SEM_TAXONOMY_UNUSED_NODE: 'Uma categoria ou tópico declarado não é usado por nenhuma questão.',

  SEM_MC_SELECTION_MISMATCH: 'A quantidade de respostas a escolher não bate com o gabarito.',
  SEM_MC_ALL_OPTIONS_CORRECT: 'Todas as alternativas estão marcadas como corretas.',
  SEM_MC_SINGLE_CORRECT_ANSWER: 'Só uma resposta é correta; isto poderia ser escolha única.',
  SEM_MATCHING_ITEM_WITHOUT_PAIR: 'Um item não tem resposta: {received}.',
  SEM_MATCHING_DUPLICATE_ITEM_PAIR: 'Um item foi associado mais de uma vez: {received}.',
  SEM_MATCHING_TARGET_REUSED: 'Um alvo é usado mais de uma vez: {received}.',
  SEM_MATCHING_UNKNOWN_REF: 'O gabarito aponta para algo que não existe: {received}.',
  SEM_MATCHING_NO_DISTRACTOR: 'Há tantos alvos quanto itens, então o último par sai de graça.',
  SEM_ORDERING_NOT_PERMUTATION: 'A ordem correta não lista cada item exatamente uma vez.',
  SEM_ORDERING_IDENTITY: 'Os itens já estão na ordem correta como foram escritos.',
  SEM_TEXT_AUTO_WITHOUT_ACCEPTED: 'Esta questão é automática mas não tem respostas aceitas.',
  SEM_TEXT_ACCEPTED_COLLIDES: 'Duas respostas aceitas ficam iguais após a normalização.',
  SEM_TEXT_SELF_WITHOUT_SAMPLE: 'Questão de autocorreção sem nada com que se comparar.',

  SEM_MEDIA_DUPLICATE_ID: 'Duas imagens desta questão têm o mesmo id.',
  SEM_MEDIA_MISSING_ALT: 'Uma imagem não tem texto alternativo.',
  SEM_MEDIA_ESSENTIAL_WITHOUT_DESCRIPTION:
    'A questão depende de uma imagem sem descrição, então não há como respondê-la sem ela.',
  SEM_MEDIA_UNRESOLVABLE: 'Uma imagem não será exibida ({received}); a descrição será usada.',
  SEM_MEDIA_TOTAL_SIZE_EXCEEDED: 'As imagens embutidas somam mais do que o permitido ({received}).',

  SEM_UNSAFE_URL: 'Um link não é uma URL https simples ({received}).',
  SEM_EXPLANATION_MISSING: 'Esta questão não tem explicação.',
  SEM_OPTION_TEXT_DUPLICATE: 'Duas alternativas dizem a mesma coisa.',
  SEM_OPTION_LOOKS_LIKE_LETTER:
    'O id de uma alternativa parece uma letra de exibição ({received}); use um id estável.',
  SEM_PROMPT_CONTAINS_MARKUP: 'Este texto contém marcação, que será exibida literalmente.',
  SEM_PROMPT_REFERENCES_MISSING_IMAGE: 'A questão menciona uma imagem mas não declara nenhuma.',
  SEM_LANGUAGE_MISMATCH: 'Esta questão está num idioma diferente do da prova.',
  SEM_LICENSE_NOT_SPDX: 'A licença {received} não é um identificador SPDX conhecido.',
  SEM_LICENSE_NOT_DECLARED: 'A prova não declara licença.',
  SEM_INVALID_DATE: 'Uma data não existe: {received}.',
};

export const ptHints: Record<string, string> = {
  FILE_READ_FAILED_HINT_RESELECT: 'Escolha o arquivo novamente.',
  FILE_NOT_UTF8_HINT_RESAVE: 'Abra num editor de texto e salve como UTF-8.',
  JSON_SYNTAX_HINT_TRUNCATED: 'O arquivo parece cortado — confira se o download terminou.',
  DETECT_MISSING_KIND_HINT_ADD: 'Adicione "kind": "exam" como primeira propriedade.',
  DETECT_WRONG_KIND_HINT_SESSION_FILE: 'Abra-o pela tela de resultados.',
  DETECT_UNSUPPORTED_MAJOR_HINT_UPDATE_APP: 'Atualize o app para abrir este arquivo.',
  DETECT_UNSUPPORTED_MAJOR_HINT_TOO_OLD: 'Esta versão do formato não é mais suportada.',
  SCHEMA_CONTENT_HASH_HINT_REMOVE: 'Apague a propriedade contentHash.',
  SCHEMA_UNKNOWN_PROPERTY_HINT_TYPO: 'Confira a grafia no schema.',
  SEM_UNKNOWN_CORRECT_OPTION_HINT: 'Corrija o gabarito, ou adicione a alternativa que falta.',
  SEM_UNKNOWN_TAXONOMY_REF_HINT_DID_YOU_MEAN: 'Você quis dizer {suggestion}?',
  SEM_TAXONOMY_NOT_DECLARED_HINT: 'Declare exam.taxonomy para que as categorias sejam conferidas.',
  SEM_MC_ALL_OPTIONS_CORRECT_HINT: 'Confira o gabarito — normalmente é erro de conversão.',
  SEM_ORDERING_IDENTITY_HINT: 'Liste os itens numa ordem diferente da resposta.',
  SEM_TEXT_SELF_WITHOUT_SAMPLE_HINT: 'Adicione um sampleAnswer para servir de comparação.',
  SEM_MEDIA_ESSENTIAL_WITHOUT_DESCRIPTION_HINT:
    'Descreva o que a imagem mostrava, com detalhe suficiente para responder.',
  SEM_MEDIA_UNRESOLVABLE_HINT_REMOTE: 'Embuta a imagem, ou confie na descrição.',
  SEM_MEDIA_UNRESOLVABLE_HINT_PACKAGE: 'Pacotes de prova ainda não são suportados.',
  SEM_OPTION_LOOKS_LIKE_LETTER_HINT: 'Use ids como "opt-1"; as letras são atribuídas pelo player.',
  SEM_PROMPT_CONTAINS_MARKUP_HINT: 'O schema 1.0 não tem Markdown nem HTML — escreva texto puro.',
  SEM_PROMPT_REFERENCES_MISSING_IMAGE_HINT: 'Adicione uma entrada de mídia descrevendo a imagem.',
  SEM_LICENSE_NOT_DECLARED_HINT: 'Adicione exam.license, por exemplo "CC-BY-4.0".',
};
